<!-- Przycisk zamknij -->
<button mat-icon-button [mat-dialog-close]="null" (click)="close()"
    class="!absolute !top-3 !right-3 !w-9 !h-9 text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-400 transition-colors !z-10">
    <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-5 !h-5"></mat-icon>
</button>

<!-- Nagłówek - wycentrowany, premium -->
<div class="flex flex-col items-center pt-8 px-8 pb-3">
    <div class="header-icon-frame mb-4">
        @if (twoFactorActive) {
            <mat-icon [svgIcon]="'tabler_outline:shield-lock'" class="text-primary !w-7 !h-7"></mat-icon>
        } @else {
            <mat-icon [svgIcon]="'tabler_outline:users-group'" class="text-primary !w-7 !h-7"></mat-icon>
        }
    </div>

    <h2 class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white m-0 text-center">
        @if (twoFactorActive) {
            Weryfikacja dwuetapowa
        } @else {
            Powiązane konta
        }
    </h2>

    <p class="text-sm text-gray-500 dark:text-gray-400 mt-2 mb-0 text-center leading-relaxed max-w-[340px]">
        @if (twoFactorActive && twoFactorMethod === 'email') {
            Wprowadź 6-cyfrowy kod wysłany na&nbsp;adres&nbsp;<strong class="text-primary font-medium">{{ twoFactorMaskedEmail }}</strong>
        } @else if (twoFactorActive && twoFactorMethod === 'authenticator') {
            Wprowadź 6-cyfrowy kod z aplikacji&nbsp;uwierzytelniającej
        } @else {
            Przełączaj się między kontami jednym kliknięciem
        }
    </p>
</div>

<mat-dialog-content class="dialog-content !px-6 !pt-3 !pb-2">

    <!-- ============================== STAN: 2FA ============================== -->
    @if (twoFactorActive) {
        <div class="max-w-[360px] mx-auto pt-4 pb-4">
            <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Kod weryfikacyjny</mat-label>
                <input matInput
                    [(ngModel)]="twoFactorCode"
                    autocomplete="one-time-code"
                    inputmode="numeric"
                    maxlength="6"
                    placeholder="000000"
                    (keydown.enter)="verify2fa()">
                <mat-icon matPrefix [svgIcon]="'tabler_outline:key'"></mat-icon>
            </mat-form-field>

            @if (twoFactorError) {
                <div class="flex items-start gap-2 px-3 py-2.5 rounded-lg bg-red-50 dark:bg-red-950/30 border border-red-200/60 dark:border-red-800/30 mt-1 mb-2">
                    <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="text-red-500 !w-4 !h-4 flex-shrink-0 mt-0.5"></mat-icon>
                    <span class="text-xs text-red-700 dark:text-red-400 leading-relaxed">{{ twoFactorError }}</span>
                </div>
            }
        </div>
    } @else {

        <!-- ============================== TABS ============================== -->
        <mat-tab-group [(selectedIndex)]="selectedTab" mat-stretch-tabs="false" mat-align-tabs="start"
            animationDuration="200ms" class="add-account-tabs">

            <!-- ============================== TAB 1: DODAJ ============================== -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>{{ (accounts.length > 0 || currentEmail) ? 'Powiąż kolejne konto' : 'Powiąż konto' }}</span>
                </ng-template>

                <form [formGroup]="attachForm" (ngSubmit)="submit()" class="pt-5 pb-2">

                    <mat-form-field class="w-full" subscriptSizing="dynamic">
                        <mat-label>Adres e-mail</mat-label>
                        <input matInput type="email" formControlName="emailAddress" autocomplete="off"
                            placeholder="np. anna@firma.pl">
                        <mat-icon matPrefix [svgIcon]="'tabler_outline:mail'"></mat-icon>
                        <mat-error *ngIf="attachForm.get('emailAddress')?.hasError('required')">
                            Adres e-mail jest wymagany
                        </mat-error>
                        <mat-error *ngIf="attachForm.get('emailAddress')?.hasError('email')">
                            Nieprawidłowy format adresu e-mail
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full mt-3" subscriptSizing="dynamic">
                        <mat-label>Hasło</mat-label>
                        <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password"
                            autocomplete="new-password">
                        <mat-icon matPrefix [svgIcon]="'tabler_outline:lock'"></mat-icon>
                        <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword"
                            [attr.aria-label]="showPassword ? 'Ukryj hasło' : 'Pokaż hasło'" tabindex="-1">
                            <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"
                                class="!w-5 !h-5 text-gray-400"></mat-icon>
                        </button>
                        <mat-error *ngIf="attachForm.get('password')?.hasError('required')">
                            Hasło jest wymagane
                        </mat-error>
                    </mat-form-field>

                    @if (attachError) {
                        <div class="flex items-start gap-2 px-3 py-2.5 rounded-lg bg-red-50 dark:bg-red-950/30 border border-red-200/60 dark:border-red-800/30 mb-1">
                            <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="text-red-500 !w-4 !h-4 flex-shrink-0 mt-0.5"></mat-icon>
                            <span class="text-xs text-red-700 dark:text-red-400 leading-relaxed">{{ attachError }}</span>
                        </div>
                    }

                    <div class="flex items-start gap-2.5 px-3 py-2.5 rounded-lg bg-primary/5 dark:bg-primary/10 mt-3">
                        <mat-icon [svgIcon]="'tabler_outline:info-circle'" class="text-primary !w-4 !h-4 flex-shrink-0 mt-0.5"></mat-icon>
                        <span class="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
                            Możesz powiązać do <strong>10 kont</strong>. Powiązanie jest dwustronne — drugie konto również Cię zobaczy.
                        </span>
                    </div>
                </form>
            </mat-tab>

            <!-- ============================== TAB 2: LISTA ============================== -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>Twoje konta</span>
                    @if (accounts.length > 0 || currentEmail) {
                        <span class="tab-badge">{{ accounts.length + (currentEmail ? 1 : 0) }}</span>
                    }
                </ng-template>

                <div class="pt-5 pb-2">
                    @if (isLoadingList) {
                        <div class="flex justify-center py-10">
                            <mat-spinner diameter="32"></mat-spinner>
                        </div>
                    } @else {
                        <ul class="flex flex-col gap-2 list-none p-0 m-0">

                            <!-- Aktualne konto - bez akcji -->
                            @if (currentEmail) {
                                <li class="account-card account-card--current" aria-current="true">
                                    <div class="account-avatar account-avatar--current">
                                        {{ getCurrentInitial() }}
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <div class="text-[14px] font-semibold tracking-tight text-gray-900 dark:text-white truncate leading-snug">
                                            {{ currentCompanyName || currentEmail }}
                                        </div>
                                        @if (currentCompanyName) {
                                            <div class="text-[12px] text-gray-500 dark:text-gray-400 truncate mt-0.5">
                                                {{ currentEmail }}
                                            </div>
                                        }
                                    </div>

                                    <span class="current-badge flex-shrink-0">
                                        <span class="current-badge__dot"></span>
                                        Aktualne
                                    </span>
                                </li>
                            }

                            @if (accounts.length === 0 && !currentEmail) {
                                <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
                                    <div class="w-14 h-14 rounded-2xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-3">
                                        <mat-icon [svgIcon]="'tabler_outline:users-off'" class="text-gray-400 !w-7 !h-7"></mat-icon>
                                    </div>
                                    <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 m-0">Żadnych powiązań</p>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-1.5 mb-0 max-w-[260px]">
                                        Przejdź do zakładki „Powiąż konto", aby dodać swoje pierwsze konto.
                                    </p>
                                </div>
                            }

                            @for (acc of accounts; track acc._id) {
                                <li class="account-card group" tabindex="0">
                                    <div class="account-avatar">
                                        {{ getInitial(acc) }}
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <div class="text-[14px] font-semibold tracking-tight text-gray-900 dark:text-white truncate leading-snug">
                                            {{ acc.companyName || acc.email }}
                                        </div>
                                        @if (acc.companyName) {
                                            <div class="text-[12px] text-gray-500 dark:text-gray-400 truncate mt-0.5">
                                                {{ acc.email }}
                                            </div>
                                        }
                                    </div>

                                    <div class="flex items-center gap-1 flex-shrink-0">
                                        <button mat-flat-button color="primary"
                                            class="account-switch-btn"
                                            (click)="switchTo(acc)">
                                            Przełącz
                                        </button>
                                        <button mat-icon-button
                                            class="account-unlink-btn"
                                            (click)="unlink(acc)"
                                            matTooltip="Odłącz konto"
                                            aria-label="Odłącz konto">
                                            <mat-icon [svgIcon]="'tabler_outline:unlink'" class="!w-[18px] !h-[18px]"></mat-icon>
                                        </button>
                                    </div>
                                </li>
                            }
                        </ul>
                    }
                </div>
            </mat-tab>
        </mat-tab-group>
    }
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer !px-6 !pb-5 !pt-3">
    @if (twoFactorActive) {
        <button mat-button type="button" (click)="cancelTwoFactor()" [disabled]="is2faVerifying"
            class="!text-gray-500 dark:!text-gray-400">
            Wstecz
        </button>
        <button mat-flat-button color="primary" type="button" (click)="verify2fa()"
            [disabled]="is2faVerifying || !twoFactorCode" class="!min-w-[140px]">
            @if (is2faVerifying) {
                <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
            } @else {
                <span class="inline-flex items-center">
                    <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4 !mr-1"></mat-icon>
                    Potwierdź
                </span>
            }
        </button>
    } @else if (selectedTab === 0) {
        <button mat-button type="button" (click)="close()" [disabled]="isAttaching"
            class="!text-gray-500 dark:!text-gray-400">
            Anuluj
        </button>
        <button mat-flat-button color="primary" type="button" (click)="submit()"
            [disabled]="isAttaching || attachForm.invalid" class="!min-w-[140px]">
            @if (isAttaching) {
                <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
            } @else {
                <span class="inline-flex items-center">
                    <mat-icon [svgIcon]="'tabler_outline:link'" class="!w-4 !h-4 !mr-1"></mat-icon>
                    {{ (accounts.length > 0 || currentEmail) ? 'Powiąż kolejne konto' : 'Powiąż konto' }}
                </span>
            }
        </button>
    } @else {
        <button mat-button type="button" (click)="close()" class="!text-gray-500 dark:!text-gray-400">
            Zamknij
        </button>
    }
</mat-dialog-actions>
